import React from 'react';

const BoatIcon = ({ fill = "rgb(0, 86, 125)", width="40px"}) => {
  return (
    <svg width={width} viewBox="0 0 144 144">
      <g>
        <path fill={fill}
          className="st2"
          d="M117.3,104.8l10.7,6.3c0.7,0.4,1.5,0.2,1.9-0.5l2.2-3.7c0.4-0.7,0.2-1.5-0.5-1.9L121,98.6
		C119.9,100.7,118.7,102.8,117.3,104.8"
        />
        <path fill={fill}
          className="st2"
          d="M95.5,24.3c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2C97.7,23.3,96.7,24.3,95.5,24.3
		 M122.4,43.9c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2C120.2,44.8,121.2,43.9,122.4,43.9 M129.5,83.7
		c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2C127.4,84.7,128.3,83.7,129.5,83.7 M126.5,75c0,7.9-1.7,15.3-4.8,22
		l8.6,5.1c4-8.2,6.2-17.4,6.2-27.1c0-30.2-21.5-55.4-50-61.1V24c0,0,0,0.1,0,0.2C109.5,29.7,126.5,50.4,126.5,75"
        />
        <path fill={fill}
          className="st2"
          d="M109.5,121.5c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2
		C111.7,120.6,110.7,121.5,109.5,121.5 M71.5,133.6c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2
		C73.7,132.7,72.7,133.6,71.5,133.6 M35.9,119.4c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2
		C38,118.4,37.1,119.4,35.9,119.4 M74.1,127.4c-17.3,0-32.6-8.4-42.1-21.2l-8.6,5.1c11.3,15.8,29.8,26.1,50.7,26.1
		c20.9,0,39.4-10.3,50.7-26.1l-8.6-5.1C106.7,119.1,91.4,127.4,74.1,127.4"
        />
        <path fill={fill}
          className="st2"
          d="M15.1,83.9c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2C16.1,86.1,15.1,85.1,15.1,83.9
		 M24.1,44.6c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2s-2.2-1-2.2-2.2C21.9,45.6,22.9,44.6,24.1,44.6 M53.6,20c1.2,0,2.2,1,2.2,2.2
		c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2C51.4,20.9,52.4,20,53.6,20 M26.6,97c-3.1-6.7-4.8-14.1-4.8-22
		c0-25.3,17.9-46.3,41.7-51.3V13.6C34.1,18.7,11.8,44.2,11.8,75c0,9.7,2.2,18.9,6.2,27.1L26.6,97z"
        />
        <path fill={fill}
          className="st2"
          d="M27.3,98.6L17,104.7c-0.7,0.4-0.9,1.3-0.5,1.9l2.3,3.8c0.4,0.7,1.3,0.9,1.9,0.5l10.2-6.1
		C29.6,102.9,28.4,100.8,27.3,98.6"
        />
        <path fill={fill}
          className="st2"
          d="M74.1,22c3.6,0,7.2,0.4,10.7,1.1l0-11.7c0-1.2-0.9-2.1-2.1-2.1H67.3c-1.2,0-2.1,1-2.1,2.1l0,11.3
		C68.1,22.2,71.1,22,74.1,22"
        />
        <path fill={fill}
          className="st2"
          d="M74.1,114.5c-21.8,0-39.5-17.7-39.5-39.5c0-21.8,17.7-39.5,39.5-39.5c21.8,0,39.5,17.7,39.5,39.5
		C113.6,96.9,95.9,114.5,74.1,114.5 M74.1,24.7c-27.8,0-50.4,22.6-50.4,50.4c0,27.8,22.6,50.4,50.4,50.4c27.8,0,50.4-22.6,50.4-50.4
		C124.5,47.2,101.9,24.7,74.1,24.7"
        />
      </g>
    </svg>
  )
}

export default BoatIcon;
